import { render } from "./DownYearlyPayrollReport.vue?vue&type=template&id=13f599b0"
import script from "./DownYearlyPayrollReport.vue?vue&type=script&lang=js"
export * from "./DownYearlyPayrollReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__